import { Box, Heading } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { TLocalesKeys as K } from '../../../../types';
import { selectUserName } from '../../../common/selectors/user';
import { renderModel } from '../../../util/renderModel';
import Typewriter from '../Typewriter/Typewriter';
import s from './styles.scss';

const isWidget = renderModel.isWidget();
const isCopilot = renderModel.isCopilot();

const AiText: FC<{ text: string }> = ({ text }) => <span className={s.aiText}>{text}</span>;

export const AiChatbotWelcomeScreen: FC = () => {
  const userName = useSelector(selectUserName);
  const { t } = useTranslation();

  if (isCopilot) {
    return (
      <Box className={s.copilotWelcomeScreen} overflow="hidden">
        <Heading size="large" ellipsis className={s.copilotWelcomeScreenHeading}>
          {userName?.first ? (
            <Trans
              i18nKey="user_greeting_with_first_name"
              components={{
                FirstName: <AiText text={userName?.first} />,
              }}
              values={{ firstName: userName?.first }}
            />
          ) : (
            <span className={s.aiText}>
              <Typewriter text={t<K>('user_greeting_no_first_name')} />
            </span>
          )}
        </Heading>
      </Box>
    );
  }

  return (
    <Box paddingTop="SP3" paddingLeft={isWidget ? 1 : 0} overflow="hidden" direction="vertical">
      <Heading size="extraLarge" ellipsis>
        {userName?.first ? (
          <Trans
            i18nKey="user_greeting_with_first_name"
            components={{
              FirstName: <AiText text={userName?.first} />,
            }}
            values={{ firstName: userName?.first }}
          />
        ) : (
          <span className={s.aiText}>
            <Typewriter text={t<K>('user_greeting_no_first_name')} />
          </span>
        )}
      </Heading>
    </Box>
  );
};
